import Ajax from '../../../common/js/Ajax.js';
import ButtonUtils from '../../../common/js/ButtonUtils.js';
import DatePickerWidget from '../../../common/js/datepicker/DatePickerWidget.js';
import DaySpanUtils from './DaySpanUtils.js';
import Dialog from '../../../common/js/dialog/Dialog.js';
import DropDownWidget from '../../../common/js/dropdown/DropDownWidget.js';
import Form from '../../../common/js/form/Form.js';
import Marshaller from './Marshaller.js';
import SmoothUtils from './SmoothUtils.js';
import Widget from '../../../common/js/Widget.js';
import WidgetLoader from '../../../common/js/WidgetLoader.js';
import ZeptoUtils from '../../../common/js/ZeptoUtils.js';

import COLORS from './colors.js';
import NEW_PROJECT from './new-project.js';
import TYPES from './types.js';

import EDIT_PHASE_TEMPLATE from './ProjectWidget-edit-phase.hbs';
import EDIT_PROJECT_TEMPLATE from './ProjectWidget-edit-project.hbs';
import EDIT_SPRINT_TEMPLATE from './ProjectWidget-edit-sprint.hbs';
import ERROR404_TEMPLATE from './ProjectWidget-error404.hbs';
import ERROR500_TEMPLATE from './ProjectWidget-error500.hbs';
import LOADING_TEMPLATE from './ProjectWidget-loading.hbs';
import NEW_PROJECT_MESSAGES_TEMPLATE from './ProjectWidget-new-project-messages.hbs';
import PHASE_VALIDATION_ERROR_TEMPLATE from './ProjectWidget-phase-validation-error.hbs';
import PROJECT_EDIT_BAR_TEMPLATE from './ProjectWidget-project-edit-bar.hbs';
import PROJECT_TEMPLATE from './ProjectWidget-project.hbs';
import SPRINT_PHASES_TEMPLATE from './ProjectWidget-sprint-phases.hbs';
import VALIDATION_ERRORS_TEMPLATE from './ProjectWidget-validation-errors.hbs';
import VIEW_ID_ALREADY_EXISTS_TEMPLATE from './ProjectWidget-view-id-already-exists.hbs';

const EDIT_PATTERN = /^\/e\/([a-zA-Z0-9-]{20})/;
const VIEW_PATTERN = /^\/([a-zA-Z0-9-]{6,30})$/;

const VIEW_CELLS = 41;

const MAX_PHASES_PER_SPRINT = 20;
const MAX_SPRINTS = 100;

export default class ProjectWidget extends Widget {

	constructor($widget) {
		super($widget);
		var pathName = window.location.pathname;
		if (pathName.match(EDIT_PATTERN)) {
			this.editId = pathName.replace(EDIT_PATTERN, '$1');
		} else if (pathName.match(VIEW_PATTERN)) {
			this.viewId = pathName.replace(VIEW_PATTERN, '$1');
		}

		if (this.editId || this.viewId) {
			$widget.find('.js_project').html(LOADING_TEMPLATE());

			Ajax.rpc(this.editId ? '/getFingerForEdit' : '/getFingerForView', {
				editId: this.editId,
				viewId: this.viewId
			}, projectJson => {
				this.handleProjectResponse(projectJson);
			}, error => {
				$('.header, .page-content').remove();
				if (error.code >= 400 && error.code <= 499) {
					$('body').prepend(ERROR404_TEMPLATE());
				} else {
					$('body').prepend(ERROR500_TEMPLATE());
				}
			});

			$(window).resize(() => {
				this.updateGridPhases();
				this.updateGridFinger();
			});

			window.setInterval(() => {
				if (!this.today) {
					this.updateGrid();
				} else if (this.today.getDate() != new Date().getDate() && this.today.getHours() >= 2) {
					window.location.reload();
				} else {
					this.updateGridFinger();
				}
			}, 60000);
		} else {
			this.project = NEW_PROJECT;
			this.handleProjectResponse();
			this.editProject();
		}

		$widget.on('change', '.js_phase-offset-unit', event => {
			this.updatePhaseValueVisibility($(event.currentTarget).closest('.js_phase'));
		});
	}

	deleteSprint($button) {
		var sprintNo = this.getSprintIndex($button);
		if (sprintNo >= this.project.sprints.length)
			return;

		Dialog.question('Confirm sprint deletion',
			'Are you sure to delete this sprint (row)?\nThis cannot be undone!',
			true, 'Delete sprint',
			() => {
				var deletedSprint = this.project.sprints.splice(sprintNo, 1)[0];
				ButtonUtils.setState($button, 'active');
				this.saveProject(true, null, () => {
					ButtonUtils.setState($button, 'success');
					this.updateGrid();
				}, () => {
					ButtonUtils.setState($button, 'none');
					this.project.sprints.splice(sprintNo, 0, deletedSprint);
				});
			});
	}

	editProject() {
		if (this.$widget.find('.js_edit-form').length) {
			return;
		}

		this.toggleEditControls(false, () => {
			this.$widget.append(EDIT_PROJECT_TEMPLATE({
				project: this.project,
				editId: this.editId,
				viewId: this.viewId,
				viewUrlPrefix: this.getViewUrlPrefix(),
				types: TYPES,
				colors: COLORS
			}));
			var $projectForm = this.$widget.find('.js_project-form');
			this.initializeEditForm($projectForm);

			$projectForm.find('.js_autosprint-enabled').change(() => {
				var autoSprintEnabled = $projectForm.find('.js_autosprint-enabled:checked').val() == 'true';
				$projectForm.find('.js_autosprint').toggle(autoSprintEnabled);

				if (autoSprintEnabled) {
					var autoSprintEveryDays = DaySpanUtils.readFormDaySpan($projectForm, '.js_autosprint-everydays');
					autoSprintEveryDays = Marshaller.marshallDaySpan(autoSprintEveryDays);
					if (autoSprintEveryDays <= 0) {
						DaySpanUtils.writeFormDaySpan($projectForm, '.js_autosprint-everydays', {value: 1, unit: 'w'});
					}
				}
			});

			$projectForm.find('.js_advanced-options-toggle').click(() => {
				$projectForm.find('.js_advanced-options-toggle-container').remove();
				$projectForm.find('.js_advanced-options:not(.form__row)').css('display', 'block');
				$projectForm.find('.js_advanced-options.form__row').css('display', 'flex');
			});

			$projectForm.find('.js_save-project').click(() => {this.endEditProject(true);});
			$projectForm.find('.js_cancel-project').click(() => {this.endEditProject(false);});
		});
	}

	editSprint(sprintNo) {
		if (this.$widget.find('.js_edit-form').length) {
			return;
		}

		if (sprintNo === undefined) {
			Ajax.rpc('/nextAutoName', {
				editId: this.editId
			}, nextName => {
				var sprint = Marshaller.unmarshallSprint(Marshaller.marshallSprint(this.project.autoSprintTemplate));
				sprint.name = nextName.name;
				this.project.autoSprintTemplate.name = nextName.pattern;
				this.editSprintInternal(undefined, $(), sprint);
			});
		} else {
			var $sprint = $('.js_grid .js_sprint').eq(sprintNo);
			var sprint = this.project.sprints[sprintNo];
			if (!sprint || !$sprint.length)
				return;

			this.editSprintInternal(sprintNo, $sprint, sprint);
		}
	}

	editSprintInternal(sprintNo, $sprint, sprint) {
		if (this.$widget.find('.js_edit-form').length) {
			return;
		}

		this.editedSprintNo = sprintNo;

		this.toggleEditControls(false, () => {
			this.$widget.append(EDIT_SPRINT_TEMPLATE({
				sprint: sprint,
				types: TYPES,
				colors: COLORS
			}));
			var $sprintForm = this.$widget.find('.js_sprint-form');
			this.initializeEditForm($sprintForm);

			$sprintForm.find('.js_save-sprint').click(() => {this.endEditSprint($sprint, sprint);});
			$sprintForm.find('.js_cancel-sprint').click(() => {this.endEditSprint();});
		});
	}

	endEditProject(save) {
		var $projectForm = this.$widget.find('.js_project-form');
		if (!$projectForm.length) {
			return;
		}

		$projectForm.find('.js_messages').empty();

		if (save) {
			var errors = Form.validate($projectForm);
			if (errors.length) {
				$projectForm.find('.js_messages').html(VALIDATION_ERRORS_TEMPLATE());
				return;
			}

			var autoSprintPhases = this.readFormPhasesAndReorder($projectForm.find('.js_phases-container'));
			var endOffset = DaySpanUtils.readFormDaySpan($projectForm, '.js_end');
			if (!this.validatePhases(autoSprintPhases, endOffset, $projectForm)) {
				return;
			}

			this.project.name = $projectForm.find('.js_name').val();

			if (!this.project.autoSprintTemplate) {
				this.project.autoSprintTemplate = {};
			}

			this.project.autoSprintTemplate.phases = autoSprintPhases;
			this.project.autoSprintTemplate.endOffset = endOffset;

			if (ZeptoUtils.isVisible($projectForm.find('.js_autosprint'))) {
				this.project.autoSprintEveryDays = DaySpanUtils.readFormDaySpan($projectForm, '.js_autosprint-everydays');
				if (ZeptoUtils.isVisible($projectForm.find('.js_advanced-options'))) {
					this.project.autoSprintTemplate.name = $projectForm.find('.js_autosprint-name').val();
					this.project.autoSprintDaysAhead = DaySpanUtils.readFormDaySpan($projectForm, '.js_autosprint-daysahead');
					this.project.sprintsToKeep = parseInt($projectForm.find('.js_sprints-to-keep').val(), 10);
				}
			} else {
				this.project.autoSprintEveryDays = 0;
			}

			var $viewId = $projectForm.find('.js_view-id');
			var newViewId = $viewId.val();
			if (newViewId && newViewId != this.viewId) {
				Ajax.rpc('/existsViewId', {viewId: newViewId}, exists => {
					if (exists) {
						Form.showFieldError({$field: $viewId});
						$projectForm.find('.js_messages').html(VIEW_ID_ALREADY_EXISTS_TEMPLATE());
					} else {
						this.endEditProjectInternally(newViewId);
					}
				});
			} else {
				this.endEditProjectInternally(null);
			}
		} else {
			SmoothUtils.remove($projectForm, () => {
				this.toggleEditControls(true);
			});
		}
	}

	endEditProjectInternally(newViewId) {
		var newProject = !this.editId;
		this.saveProject(false, newViewId, () => {
			if (newProject) {
				sessionStorage['newProject'] = 'true';
				window.location.href = '/e/' + this.editId;
			} else {
				SmoothUtils.remove(this.$widget.find('.js_project-form'), () => {
					this.toggleEditControls(true);
					this.updateGrid();
				});
			}
		});
	}

	endEditSprint(save) {
		var $sprintForm = this.$widget.find('.js_sprint-form');
		if (!$sprintForm.length) {
			return;
		}

		$sprintForm.find('.js_messages').empty();

		if (save) {
			var errors = Form.validate($sprintForm);
			if (errors.length) {
				$sprintForm.find('.js_messages').html(VALIDATION_ERRORS_TEMPLATE());
				return;
			}

			var phases = this.readFormPhasesAndReorder($sprintForm.find('.js_phases-container'));
			var endOffset = DaySpanUtils.readFormDaySpan($sprintForm, '.js_end');
			if (!this.validatePhases(phases, endOffset, $sprintForm)) {
				return;
			}

			var sprint;
			if (this.editedSprintNo === undefined || this.editedSprintNo >= this.project.length) {
				sprint = {};
			} else {
				sprint = this.project.sprints[this.editedSprintNo];
			}

			sprint.name = $sprintForm.find('.js_name').val();
			sprint.start = DatePickerWidget.getDate($sprintForm.find('.js_start'));
			sprint.phases = phases;
			sprint.endOffset = endOffset;

			if (this.editedSprintNo === undefined || this.editedSprintNo >= this.project.sprints.length) {
				this.project.sprints.push(sprint);
			}

			this.saveProject(true, null, () => {
				this.editedSprintNo = null;
				SmoothUtils.remove($sprintForm, () => {
					this.toggleEditControls(true);
					this.updateGrid();
				});
			});
		} else {
			SmoothUtils.remove($sprintForm, () => {
				this.toggleEditControls(true);
			});

			this.editedSprintNo = null;
		}
	}

	getClassesForType(value) {
		var classes = null;
		$.each(TYPES, (index, type) => {
			if (type.value == value) {
				classes = type.classes;
				return false;
			}
		});
		return classes;
	}

	getCellOffset(cellNo, $row, rowLeft) {
		if (cellNo < 0) {
			return -15;
		} else if (cellNo >= VIEW_CELLS) {
			return $row.width() + 15;
		} else {
			var $cell = $row.find('.grid__cells__cell').eq(cellNo);
			return $cell.offset().left - rowLeft;
		}
	}

	getCellWidth(cellNo, $row) {
		if (cellNo < 0 || cellNo >= VIEW_CELLS) {
			return 0;
		} else {
			var $cell = $row.find('.grid__cells__cell').eq(cellNo);
			return $cell.width();
		}
	}

	getFirstCellDate() {
		var day = new Date().set({hour:0, minute:0, second:0, millisecond:0});
		day.add(-parseInt(VIEW_CELLS * 3 / 10)).days();
		return day;
	}

	getSprintIndex($element) {
		var index = $element.closest('.js_sprint').attr('data-index');
		if (typeof(index) !== 'string') {
			throw new Error('Element is no sprint row');
		}

		return parseInt(index);
	}

	getViewUrlPrefix() {
		return window.location.protocol + '//' + window.location.host + '/';
	}

	handleProjectResponse(projectJson) {
		if (projectJson) {
			if (projectJson.editId) {
				this.editId = projectJson.editId;
			}

			if (projectJson.viewId) {
				this.viewId = projectJson.viewId;
			}

			this.project = Marshaller.unmarshallProject(Ajax._unmarshallValue(projectJson.data));
		}

		this.updateHeadline();

		if (this.editId) {
			this.updateGrid();

			// Prevent stuttering when opening/closing project edit
			$('body').css('overflow-y', 'scroll');

			$('.js_whats-this').remove();
		} else if (this.viewId) {
			this.updateGrid();
		} else {
			$('.js_whats-this').remove();
		}

		if (sessionStorage['newProject'] == 'true') {
			sessionStorage.removeItem('newProject');

			this.$widget.after(NEW_PROJECT_MESSAGES_TEMPLATE({
				viewUrl: this.getViewUrlPrefix() + this.viewId
			}));
		}
	}

	initializeEditForm($editForm) {
		WidgetLoader.initialize();

		$editForm.find('.js_phase').each((index, phase) => {
			this.updatePhaseValueVisibility($(phase));
		});

		$editForm.on('click', '.js_delete-phase', event => {
			$(event.currentTarget).closest('.js_phase').remove();

			if ($editForm.find('.js_phase').length < MAX_PHASES_PER_SPRINT) {
				$editForm.find('.js_add-phase').show();
			}
		});

		$editForm.find('.js_add-phase').click(() => {
			$editForm.find('.js_phases-container').append(EDIT_PHASE_TEMPLATE({
				types: TYPES,
				colors: COLORS
			}));

			WidgetLoader.initialize();

			if ($editForm.find('.js_phase').length >= MAX_PHASES_PER_SPRINT) {
				$editForm.find('.js_add-phase').hide();
			}
		});

		window.setTimeout(() => {
			$editForm.removeClass('transparent');
		}, 1);

		$editForm.find('.js_name').focus();
	}

	readFormPhasesAndReorder($container) {
		var $phases = [];
		$container.find('.js_phase').each((index, phase) => {
			$phases.push($(phase));
		});
		$container.find('.js_phase').detach();

		$phases.sort(($phase1, $phase2) => {
			var phase1Offset = Marshaller.marshallDaySpan(DaySpanUtils.readFormDaySpan($phase1, '.js_phase-offset'));
			var phase2Offset = Marshaller.marshallDaySpan(DaySpanUtils.readFormDaySpan($phase2, '.js_phase-offset'));
			return phase1Offset - phase2Offset;
		});
		$.each($phases, (index, phase) => {
			$container.append(phase);
		});

		var phases = [];
		$container.find('.js_phase').each((index, phaseElement) => {
			var $phase = $(phaseElement);

			var phase = {};
			phase.name = $phase.find('.js_phase-name').val();
			phase.offset = DaySpanUtils.readFormDaySpan($phase, '.js_phase-offset');
			phase.type = DropDownWidget.getValue($phase.find('.js_phase-type'));
			phase.color = DropDownWidget.getValue($phase.find('.js_phase-color'));
			phases.push(phase);
		});

		return phases;
	}

	saveProject(suppressUpdates, newViewId, successCallback, errorCallback) {
		Ajax.rpc('/saveFinger', {
			id: this.editId,
			data: Marshaller.marshallProject(this.project),
			viewId: newViewId,
			suppressUpdates: suppressUpdates
		}, projectJson => {
			this.handleProjectResponse(projectJson);
			if (successCallback) successCallback();
		}, () => {
			if (errorCallback) errorCallback();
			Dialog.warning('Save project failed',
				'Oh snap. We encountered technical difficulties\n'
				+ 'while saving your Sprint Finger.\n\n'
				+ 'Please try again later.');
		});
	}

	toggleEditControls(show, callback) {
		if (show) {
			SmoothUtils.visible($('.js_edit-sprint, .js_delete-sprint'));
			SmoothUtils.show($('.js_footer, .js_edit-project-bar'), callback);
		} else {
			SmoothUtils.invisible($('.js_edit-sprint, .js_delete-sprint'));
			SmoothUtils.hide($('.js_footer, .js_edit-project-bar, .js_claims'), callback);
		}
	}

	updateGrid() {
		if (!this.project)
			return;

		this.today = new Date();
		var firstCellDate = this.getFirstCellDate();

		var day = firstCellDate.clone();
		this.days = [];
		for (var i=0; i<VIEW_CELLS; i++) {
			var dayOfWeek = day.getDay();
			this.days.push({
				date: day,
				day: day.getDate(),
				month: day.toString("MMMM"),
				nonWork: dayOfWeek < 1 || dayOfWeek > 5,
				today: day.getMonth() == this.today.getMonth() && day.getDate() == this.today.getDate()
			});

			day = day.clone().add(1).days();
		}

		$.each(this.project.sprints, (sprintNo, sprint) => {
			$.each(sprint.phases, (phaseNo, phase) => {
				phase.start = DaySpanUtils.getRelativeSprintDate(sprint, phase.offset);
				phase.startCell = parseInt((phase.start - firstCellDate) / 3600 / 24 / 1000 + 0.5);

				var $label = $('<span style="position:absolute; visibility:hidden"></span>');
				$label.text(phase.name);
				$('body').append($label);
				phase.labelWidth = $label.width();
				phase.labelOffset = phase.type == 'normal' ? 4 : 35;
				$label.remove();
			});

			sprint.end = DaySpanUtils.getRelativeSprintDate(sprint, sprint.endOffset);
			sprint.endCell = parseInt((sprint.end - firstCellDate) / 3600 / 24 / 1000 + 0.5);
		});

		$.each(this.project.sprints, (sprintNo, sprint) => {
			$.each(sprint.phases, (phaseNo, phase) => {
				var nextPhase = sprint.phases[phaseNo + 1];
				if (nextPhase) {
					phase.endCell = nextPhase.startCell;
					phase.nextStartCell = nextPhase.startCell;
				} else {
					phase.endCell = sprint.endCell;
					phase.nextStartCell = sprint.endCell;
				};

				while (phase.endCell > 0 && phase.endCell <= VIEW_CELLS
					&& this.days[phase.endCell - 1].nonWork) {
					phase.endCell--;
				}
			});
		});

		this.displayedSprints = $.grep(this.project.sprints, sprint => {
			if (this.editId) return true;
			if (!sprint.phases.length) return false;

			var firstDay = this.days[0].date;
			var lastDay = this.days[this.days.length - 1].date;
			var sprintStart = sprint.phases[0].start;
			return sprintStart <= lastDay && sprint.end >= firstDay;
		});

		this.$widget.find('.js_project').html(PROJECT_TEMPLATE({
			days: this.days,
			sprints: this.displayedSprints,
			edit: Boolean(this.editId)
		}));

		if (this.editId) {
			this.$widget.find('.js_grid .js_delete-sprint').click(event => {
				this.deleteSprint($(event.currentTarget));
			});

			this.$widget.find('.js_grid .js_edit-sprint').click(event => {
				this.editSprint(this.getSprintIndex($(event.currentTarget)));
			});

			if (!this.$widget.find('.js_edit-project-bar').length) {
				this.$widget.find('.js_project').after(PROJECT_EDIT_BAR_TEMPLATE());

				this.$widget.find('.js_add-sprint').click(() => {
					this.editSprint();
				});

				this.$widget.find('.js_edit-project').click(() => {
					this.editProject();
				});
			}
		}

		window.setTimeout(() => {
			this.updateGridPhases();
			this.updateGridFinger();
		}, 1);
	}

	updateGridFinger() {
		if (!this.project)
			return;

		var hour = new Date().getHours();
		var dayProgress;
		if (hour < 9) {
			dayProgress = 0;
		} else if (hour > 18) {
			dayProgress = 1;
		} else {
			dayProgress = (hour - 9) / (18 - 9);
		}

		var $grid = this.$widget.find('.js_grid');
		var $todayCell = $grid.find('.js_sprint .grid__cells__cell--today');
		if (!$todayCell.length)
			return;

		var gridLeft = $grid.offset().left;
		var todayCellLeft = $todayCell.offset().left;
		var todayCellWidth = $todayCell.width();

		var $finger = this.$widget.find('.js_finger');
		if (!$finger.length) {
			$finger = $('<div class="finger js_finger"></div>');
			$finger.insertAfter($grid);
		}

		$finger.css('left', todayCellLeft + dayProgress * todayCellWidth - gridLeft - 2);
	}

	updateGridPhases() {
		if (!this.project)
			return;

		var firstCellDate = this.getFirstCellDate();
		$.each(this.displayedSprints, (sprintNo, sprint) => {
			var $row = this.$widget.find('.js_sprint-content').eq(sprintNo);
			if (!$row.length) {
				return true;
			}
			var rowLeft = $row.offset().left;

			var phases = [];
			var lastLabelEndPx = null;
			$.each(sprint.phases, (phaseNo, phase) => {
				if (phase.startCell >= VIEW_CELLS || phase.endCell <= 0) {
					return true;
				}

				var startPx = this.getCellOffset(phase.startCell, $row, rowLeft);
				var startCellWidth = this.getCellWidth(phase.startCell, $row);
				var endPx = this.getCellOffset(phase.endCell, $row, rowLeft);
				var nextStartPx = this.getCellOffset(phase.nextStartCell, $row, rowLeft);

				var labelStartPx = startPx + phase.labelOffset;
				if (lastLabelEndPx && labelStartPx < lastLabelEndPx + 10) {
					labelStartPx = lastLabelEndPx + 10;
				}
				var labelEndPx = labelStartPx + phase.labelWidth;
				var labelVisible = labelStartPx <= nextStartPx;

				if (phase.type != 'end') {
					// Use unshift to render phases in reverse order, so that labels overlap in the right way
					phases.unshift({
						name: phase.name,
						left: startPx,
						width: phase.type == 'normal' ? endPx - startPx - 2 : startCellWidth - 2,
						type: phase.type,
						symbol: this.getClassesForType(phase.type),
						color: phase.color,
						labelLeft: labelStartPx - startPx,
						labelHidden: !labelVisible
					});
				}

				if (labelVisible)
					lastLabelEndPx = labelEndPx;
			});

			$row.find('.js_phase').remove();
			$row.append(SPRINT_PHASES_TEMPLATE(phases));
		});

		// Workaround for Firefox layout bug
		$('.phase__label').css('color', 'transparent');
		$('.phase__label').css('position', 'static');
		window.setTimeout(() => {
			$('.phase__label').css('position', '');
			$('.phase__label').css('color', '');
		}, 0);
	}

	updateHeadline() {
		var name = this.project ? this.project.name + '' : '';
		$('.js_headline').text(name);
		$('head title').text((name != '' ? name : 'New project') + ' - SPRINT|FINGER.com');

		$('.js_header').toggleClass('header--with-view-url', Boolean(this.editId));
		$('.js_view-url').toggle(Boolean(this.editId));

		if (this.editId) {
			var viewUrl = this.getViewUrlPrefix() + this.viewId;
			$('.js_view-url a').text(viewUrl);
			$('.js_view-url a').attr('href', viewUrl);
		}
	}

	updatePhaseValueVisibility($phase) {
		$phase.find('.js_phase-offset-value').closest('label').toggleClass('invisible',
			$phase.find('.js_phase-offset-unit').val() == '0');
	}

	validatePhases(phases, endOffset, $form) {
		if (phases == null || phases.length <= 0) {
			$form.find('.js_messages').html(PHASE_VALIDATION_ERROR_TEMPLATE('noPhases'));
			return false;
		}

		var error = null;
		var phaseNo;
		for (var i=0; i<phases.length; i++) {
			var currentOffset = Marshaller.marshallDaySpan(phases[i].offset);
			var lastOffset = i > 0 ? Marshaller.marshallDaySpan(phases[i-1].offset) : 0;
			if (i > 0 && currentOffset == lastOffset) {
				error = 'offsetsEqual';
				phaseNo = i;
				break;
			}

			if (currentOffset < -365 || currentOffset > 365) {
				error = 'offsetOutOfRange';
				phaseNo = i;
				break;
			}
		}
		if (error) {
			var $phase = $form.find('.js_phases-container .js_phase').eq(i);
			var $offsetValue = $phase.find('.js_phase-offset-value');
			Form.showFieldError({$field: $offsetValue});

			$form.find('.js_messages').html(PHASE_VALIDATION_ERROR_TEMPLATE(error));
			return false;
		}

		endOffset = Marshaller.marshallDaySpan(endOffset);
		if (endOffset < 0 || endOffset > 365) {
			$form.find('.js_messages').html(PHASE_VALIDATION_ERROR_TEMPLATE('endOffsetOutOfRange'));
			return false;
		}

		var lastOffset = Marshaller.marshallDaySpan(phases[phases.length - 1].offset);
		if (endOffset <= lastOffset) {
			$form.find('.js_messages').html(PHASE_VALIDATION_ERROR_TEMPLATE('endOffsetInvalid'));
			return false;
		}

		return true;
	}

}
